var isXScrollable = function isXScrollable(node) {
  var overflowX = window && window.getComputedStyle(node).overflowX;
  return overflowX !== 'visible' && overflowX !== 'hidden';
};
var isYScrollable = function isYScrollable(node) {
  var overflowY = window && window.getComputedStyle(node).overflowY;
  return overflowY !== 'visible' && overflowY !== 'hidden';
};
var isOverflowHidden = function isOverflowHidden(node) {
  var overflow = window && window.getComputedStyle(node).overflow;
  return overflow === 'hidden';
};
var canBeOffsetParent = function canBeOffsetParent(node) {
  return window.getComputedStyle(node).position !== 'static';
};
var getRelativePosition = function getRelativePosition(node, wrapper) {
  var x = 0;
  var y = 0;
  var el = node;
  while (el) {
    if (el === wrapper || el === (document && document.body) || el === null) {
      break;
    }
    x += el.offsetLeft;
    y += el.offsetTop;
    el = el.offsetParent;
  }
  // 如果wrapper能scroll并且position是static的话，还要抵消scroll带来的offset
  var isPositionedWrapper = canBeOffsetParent(wrapper);
  var isXScrollable_ = isXScrollable(wrapper);
  var isYScrollable_ = isYScrollable(wrapper);
  if (!isPositionedWrapper) {
    if (isXScrollable_) {
      x -= wrapper.scrollLeft;
    }
    if (isYScrollable_) {
      y -= wrapper.scrollTop;
    }
  }
  return {
    x: x,
    y: y
  };
};
var getFirstScrollWrapper = function getFirstScrollWrapper(node) {
  if (node === null || node === (document && document.body)) {
    return node;
  }
  var isScrollable = isXScrollable(node) || isYScrollable(node);
  if (isScrollable) {
    return node;
  }
  return getFirstScrollWrapper(node.parentNode);
};
var getFirstInvisibleWrapper = function getFirstInvisibleWrapper(node) {
  if (node === null || node === (document && document.body)) {
    return node;
  }
  var isHidden = isXScrollable(node) || isYScrollable(node) || isOverflowHidden(node);
  if (isHidden) {
    return node;
  }
  return getFirstInvisibleWrapper(node.parentNode);
};

export { canBeOffsetParent, getFirstInvisibleWrapper, getFirstScrollWrapper, getRelativePosition, isOverflowHidden, isXScrollable, isYScrollable };
